/* tslint:disable */
/* eslint-disable */
/**
 * MOBEL Proxy Api Documentation
 * MOBEL Proxy Api Documentation
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MinimalTimeFrameDTO
 */
export interface MinimalTimeFrameDTO {
    /**
     * 
     * @type {string}
     * @memberof MinimalTimeFrameDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MinimalTimeFrameDTO
     */
    name?: string;
}

export function MinimalTimeFrameDTOFromJSON(json: any): MinimalTimeFrameDTO {
    return MinimalTimeFrameDTOFromJSONTyped(json, false);
}

export function MinimalTimeFrameDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MinimalTimeFrameDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function MinimalTimeFrameDTOToJSON(value?: MinimalTimeFrameDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


